import React from 'react';
import { Transition } from 'react-transition-group';

const transitionDuration = 1000;

const defaultTransitionStyle = {
  transition: `opacity ${transitionDuration}ms ease-in-out`,
  opacity: 0,
};

const transitionStyles = {
  entering: { opacity: 1 },
  entered: { opacity: 1 },
  exiting: { opacity: 0 },
  exited: { opacity: 0 },
};

function Fade({ in: inProp, children }) {
  return (
    <Transition
      in={inProp}
      timeout={{
        appear: transitionDuration,
        enter: transitionDuration,
        exit: transitionDuration,
      }}
      appear
      unmountOnExit
    >
      {(status) => (
        <div
          className="register-component"
          style={{
            ...defaultTransitionStyle,
            ...transitionStyles[status],
          }}
        >
          {children}
        </div>
      )}
    </Transition>
  );
}

export default Fade;
